import log from '../../log';

export function mergeBehaviorActions(actions, behaviors, tagName) {
	const mergedActions = {};
	const {length: behaviorsCount} = behaviors;
	const behaviorNames = {};

	for (let i = 0; i < behaviorsCount; i++) {
		const {
			name,
			behavior: {actions: behaviorActions = {}}
		} = behaviors[i];

		for (const k in behaviorActions) {
			if (mergedActions[k]) {
				log(`Behavior ${name} overwrote action ${k} for ${tagName}.`, {
					tagName,
					origin: 'mergeBehaviorActions'
				});
			}

			mergedActions[k] = behaviorActions[k];
			behaviorNames[k] = name;
		}
	}

	for (const k in actions) {
		if (mergedActions[k]) {
			log(
				`The component definition for ${tagName} overwrote action ${k} defined by the ${behaviorNames[k]} behavior.`,
				{tagName, origin: 'mergeBehaviorActions'}
			);
		}

		mergedActions[k] = actions[k];
	}

	return mergedActions;
}
